__turbopack_context__.v({
  "BaeNotification": "notification-popup-module__2rxIDW__BaeNotification",
  "NotificationContent": "notification-popup-module__2rxIDW__NotificationContent",
  "NotificationCreatorInfo": "notification-popup-module__2rxIDW__NotificationCreatorInfo",
  "NotificationFanInfo": "notification-popup-module__2rxIDW__NotificationFanInfo",
});
